import React from "react";

export default function MemberTradeSettings() {
    return <div>MemberTradeSettings</div>;
}
